<div class="mb-2">
  <mat-expansion-panel class="accordion accordion-maintenance accordion-primary">
      <mat-expansion-panel-header>
        <mat-panel-title>
         <span class="index-number">{{ index + 1 }}</span> Etapa: {{ formGroup.get('stageName')?.value || 'Nueva Etapa' }}
        </mat-panel-title>
        <button class="button button-danger button-sm mr-2" (click)="removeStage()">
          <i class="fas fa-trash-can" aria-hidden="true"></i>
        </button>
      </mat-expansion-panel-header>
      
      <div [formGroup]="formGroup">
        <!--
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Nombre de la etapa</mat-label>
            <input matInput formControlName="stageName" placeholder="Nombre de la etapa">
          </mat-form-field>
        -->
        <div class="grid grid-cols-1 md:grid-cols-12 gap-4 mb-4">
          <input class="input md:col-span-8" type="text" formControlName="stageName" placeholder="Nombre de la etapa">
          <div *ngIf="formGroup.get('stageName')?.invalid && (formGroup.get('stageName')?.dirty || formGroup.get('stageName')?.touched)" class="text-red-500">
            El nombre de la etapa es obligatorio.
          </div>
          <input class="input md:col-span-2" type="number" formControlName="order" placeholder="Orden">
          <div *ngIf="formGroup.get('order')?.invalid && (formGroup.get('order')?.dirty || formGroup.get('order')?.touched)" class="text-red-500">
            El orden es obligatorio.
          </div>
          <mat-checkbox class="md:col-span-2" formControlName="required">Requerido</mat-checkbox>
        </div>
        <!-- Orden y Requerido fields -->
        <!--
          <div class="flex items-center mr-4">
            <mat-form-field appearance="outline" class="order-field">
              <mat-label>Orden</mat-label>
              <input matInput type="number" formControlName="order" placeholder="Orden">
            </mat-form-field>
            <mat-checkbox formControlName="required">Requerido</mat-checkbox>
          </div>
        -->
        <!-- End of Orden y Requerido fields -->
        <!--<button mat-button (click)="addTask()">Agregar Tarea</button>-->
        <div formArrayName="tasks">
          <div *ngFor="let taskCtrl of tasksFormArray.controls; let j = index" [formGroupName]="j">
            <app-task-create [index]="j" [formGroup]="getFormGroup(taskCtrl)" [tasks]="tasks" [acceptanceCriterias]="acceptanceCriterias" [isMaintenanceUpdate]="isMaintenanceUpdate" (removeTask)="removeTask(j)"></app-task-create>
          </div>
        </div>
        <div class="flex justify-end mt-2">
          <button class="button button-outlined-secondary button-sm" (click)="addTask()">Agregar Tarea</button>
        </div>
      </div>
    </mat-expansion-panel>
</div>